import { BoltFillIcon, Button } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { useOpenWindow } from '@/hooks';
export interface AiTrialBadgeProps {
  remaining: number;
  lifetimeLimit: number;
}

/**
 * AI 무료 체험 배지 컴포넌트
 *
 * 쿼터 제한 유저(비로그인 / FREE plan)에게 남은 무료 체험 횟수 표시
 * Example: "무료 체험 2/3회 남음"
 */
export const AiTrialBadge = ({
  remaining,
  lifetimeLimit
}: AiTrialBadgeProps) => {
  const {
    t
  } = useTranslation(['build']);
  const openWindow = useOpenWindow();
  const text = remaining === 0 ? t('build:build.ai.guest.quotaExhausted') : t('build:build.ai.guest.trialRemaining', {
    remaining,
    limit: lifetimeLimit
  });
  return <div className="flex flex-col gap-2xs" data-sentry-component="AiTrialBadge" data-sentry-source-file="AiTrialBadge.tsx">
      {remaining === 0 && <Button intent="gradient" variant="contained" size="lg" onClick={() => {
      openWindow('/pricing');
    }} leftSlot={<BoltFillIcon size="sm" />}>
          {t('build:build.ai.guest.upgradePlan')}
        </Button>}
      <div className="text-center text-body-md-semibold text-alternative">
        {text}
      </div>
    </div>;
};